import { TZDate } from '@date-fns/tz'
import { format, isAfter, parse } from 'date-fns'

import { bootstrapStore } from 'core/stores'

import * as R from './remeda'

const timezoneFromStore = (): string | undefined => bootstrapStore.state?.company?.timezone ?? undefined

export const getNow = (timezone: string | undefined = timezoneFromStore()) =>
  timezone ? TZDate.tz(timezone) : new Date()

const simpleDatePattern = /^\d{4}-\d{2}-\d{2}$/

const parseCalendarDateInTimezone = (value: string, timezone: string | undefined) =>
  parse(value, SIMPLE_DATE_FORMAT, getNow(timezone))

export const parseDatetime = (value: string | number, timezone: string | undefined = timezoneFromStore()) =>
  R.isString(value) && simpleDatePattern.test(value) ? parseCalendarDateInTimezone(value, timezone)
  : !timezone ? new Date(value)
  : R.isString(value) ? new TZDate(value, timezone)
  : new TZDate(value, timezone)

export const getGenericTimezone = (
  timeZone: string | undefined = timezoneFromStore(),
  timeZoneName: 'longGeneric' | 'short' | 'long' | 'shortOffset' | 'longOffset' | 'shortGeneric' = 'longGeneric',
) =>
  R.find(
    new Intl.DateTimeFormat('default', { timeZone, timeZoneName }).formatToParts(),
    (part) => part.type === 'timeZoneName',
  )?.value ?? timeZone

export const DATETIME_FORMAT = 'd MMM y, h:mm a'
export const DATE_FORMAT = 'MMM d, yyyy'
export const MONTH_DAY_FORMAT = 'MMM d'
export const TIME_FORMAT = 'h:mm a'
export const CALENDAR_DATE_FORMAT = 'MM/dd/yyyy'
export const SIMPLE_DATE_FORMAT = 'yyyy-MM-dd'
export const WEEKDAY_LONG_FORMAT = 'EEEE, MMMM do'
export const YEAR_FORMAT = 'y'

export const formatDatetime = (value: string, formatString: string, timezone?: string) =>
  format(parseDatetime(value, timezone), formatString)

export const formatDate = (value: string | null | undefined) => (value ? formatDatetime(value, DATE_FORMAT) : undefined)

export const formatToday = (timezone?: string) => format(getNow(timezone), SIMPLE_DATE_FORMAT)

export const isDatetimeAfter = (
  after: string | null | undefined,
  before: string | null | undefined,
  timezone?: string,
) => !!after && !!before && isAfter(parseDatetime(after, timezone), parseDatetime(before, timezone))
